import React from 'react';
import { BookCallButton } from './BookCallButton';
export function FinalCTA() {
  return <section className="py-20 md:py-24 px-6 md:px-12 bg-clay/20 border-t border-teal/10" data-id="element-60">
      <div className="max-w-3xl mx-auto text-center" data-id="element-61">
        <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-62">
          Ready to get clear on what's next
          <span className="text-accent" data-id="element-63">?</span>
        </h2>
        <p className="text-xl text-ink/80 mb-10 leading-relaxed" data-id="element-64">
          Book a free clarity call to see if Year One is the right fit. We will
          talk about where things feel stuck, what kind of support would help,
          and whether the Career Launch Package makes sense.
        </p>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-teal/10 text-left max-w-2xl mx-auto mb-10" data-id="element-65">
          <h3 className="font-serif text-xl mb-6 text-center" data-id="element-66">
            What we'll cover on the call:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4 text-sm text-ink/70 mb-8" data-id="element-67">
            <div className="flex items-center gap-2 bg-mist/50 p-3 rounded-lg" data-id="element-68">
              <span className="w-2 h-2 rounded-full bg-teal" data-id="element-69"></span>
              Your current situation
            </div>
            <div className="flex items-center gap-2 bg-mist/50 p-3 rounded-lg" data-id="element-70">
              <span className="w-2 h-2 rounded-full bg-teal" data-id="element-71"></span>
              Where you feel stuck
            </div>
            <div className="flex items-center gap-2 bg-mist/50 p-3 rounded-lg" data-id="element-72">
              <span className="w-2 h-2 rounded-full bg-teal" data-id="element-73"></span>
              Support you're looking for
            </div>
            <div className="flex items-center gap-2 bg-mist/50 p-3 rounded-lg" data-id="element-74">
              <span className="w-2 h-2 rounded-full bg-teal" data-id="element-75"></span>
              If the program is a fit
            </div>
          </div>

          <BookCallButton className="btn-primary w-full py-4 text-lg" data-id="element-76" />
          <p className="text-center text-sm text-accent mt-4 font-medium" data-id="element-77">
            3 spots left!
          </p>
        </div>
      </div>
    </section>;
}